<template>
  <section v-bind:id="id" class="section">
    <h2>
      <i class="material-icons left">{{ iconName }}</i>
      {{ title }}
    </h2>

    <section class="section">
      <div class="row">
        <BaseTextInput
          v-bind="form.nome"
          v-bind:disabled="readonly"
          v-bind:value="pessoaFisica.nome"
        />
        <BaseTextInput
          v-bind="form.nomeSocial"
          v-bind:disabled="readonly"
          v-bind:value="pessoaFisica.nomeSocial"
        />
        <BaseTextInput
          v-bind="form.dataNascimento"
          v-bind:disabled="readonly"
          v-bind:value="formattedDataNascimento"
        />
        <BaseTextInput
          v-bind="form.sexo"
          v-bind:disabled="readonly"
          v-bind:value="formattedSexo"
        />
        <BaseTextInput
          v-bind="form.cpf"
          v-bind:disabled="readonly"
          v-bind:value="pessoaFisica.cpf"
        />
        <BaseTextInput
          v-bind="form.estadoCivil"
          v-bind:disabled="readonly"
          v-bind:value="detalhe.estadoCivil"
        />
        <BaseTextInput
          v-bind="form.etnia"
          v-bind:disabled="readonly"
          v-bind:value="formattedEtnia"
        />
      </div>
    </section>

    <section class="section">
      <h3>Filiação</h3>
      <div class="row">
        <BaseTextInput
          v-bind="form.filiacao.nomeMae"
          v-bind:disabled="readonly"
          v-bind:value="detalhe.nomeMae"
        />
        <BaseTextInput
          v-bind="form.filiacao.nomePai"
          v-bind:disabled="readonly"
          v-bind:value="detalhe.nomePai"
        />
      </div>
    </section>

    <section class="section">
      <h3>Grupo Sanguíneo</h3>
      <div class="row">
        <BaseTextInput
          v-bind="form.grupoSanguineo.tipoSanguineo"
          v-bind:disabled="readonly"
          v-bind:value="detalhe.tipoSanguineo"
        />
        <BaseTextInput
          v-bind="form.grupoSanguineo.fatorRh"
          v-bind:disabled="readonly"
          v-bind:value="detalhe.fatorRh"
        />
      </div>
    </section>

    <section class="section">
      <h3>Nacionalidade/Naturalidade</h3>
      <div class="row">
        <BaseTextInput
          v-bind="form.nacionalidadeNaturalidade.tipo"
          v-bind:disabled="readonly"
          v-bind:value="formattedTipoNacionalidade"
        />
        <BaseTextInput
          v-if="!isBrasileiroNato"
          v-bind="form.nacionalidadeNaturalidade.pais"
          v-bind:disabled="readonly"
          v-bind:value="pais.nome"
        />
        <BaseTextInput
          v-if="!isBrasileiroNato"
          v-bind="form.nacionalidadeNaturalidade.dataChegada"
          v-bind:disabled="readonly"
          v-bind:value="formattedDataChegada"
        />
        <BaseTextInput
          v-bind="form.nacionalidadeNaturalidade.uf"
          v-bind:disabled="readonly"
          v-bind:value="municipio.uf"
        />
        <BaseTextInput
          v-bind="form.nacionalidadeNaturalidade.municipio"
          v-bind:disabled="readonly"
          v-bind:value="municipio.nome"
        />
      </div>
    </section>

    <DadosPessoaisDeficiencias
      v-bind:pessoa-fisica="pessoaFisica"
      v-bind:deficiencias="deficiencia"
    />
  </section>
</template>

<script>
import { API_URL } from "../../constants";
import DadosPessoaisDeficiencias from "./DadosPessoaisDeficiencias.vue";

export default {
  name: "DadosPessoais",
  components: {
    DadosPessoaisDeficiencias
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },

    title: String,
    iconName: String,

    pessoaFisica: {
      type: Object,
      required: true
    },
    detalhe: {
      type: Object,
      required: true
    },

    deficiencia: Array
  },
  data() {
    return {
      readonly: true,
      loadingTiposNacionalidade: false,
      loadingEtnias: false,
      loadingMunicipio: false,
      loadingPais: false,
      municipio: { uf: null, nome: null },
      pais: { nome: null },
      etnias: [],
      tiposNacionalidade: [],
      form: {
        nome: {
          id: this.buildElementId("nome"),
          label: "Nome"
        },
        nomeSocial: {
          id: this.buildElementId("nomesocial"),
          label: "Nome social",
          value: null
        },
        dataNascimento: {
          id: this.buildElementId("nascimento"),
          label: "Data de nascimento",
          gridExpression: "col s12 m6"
        },
        sexo: {
          id: this.buildElementId("sexo"),
          label: "Sexo",
          gridExpression: "col s12 m6"
        },
        cpf: {
          id: this.buildElementId("cpf"),
          label: "CPF",
          gridExpression: "col s12 m6"
        },
        estadoCivil: {
          id: this.buildElementId("estadocivil"),
          label: "Estado civil",
          gridExpression: "col s12 m6"
        },
        etnia: {
          id: this.buildElementId("etnia"),
          label: "Etnia",
          gridExpression: "col s12 m6"
        },
        saveButton: {
          type: "submit",
          iconName: "save",
          content: "Salvar"
        },
        filiacao: {
          nomeMae: {
            id: this.buildElementId("filiacao-mae"),
            label: "Mãe"
          },
          nomePai: {
            id: this.buildElementId("filiacao-pai"),
            label: "Pai"
          }
        },
        grupoSanguineo: {
          tipoSanguineo: {
            id: this.buildElementId("gruposanguineo-tipo"),
            label: "Tipo",
            gridExpression: "col s6"
          },
          fatorRh: {
            id: this.buildElementId("gruposanguineo-rh"),
            label: "RH",
            gridExpression: "col s6"
          }
        },
        nacionalidadeNaturalidade: {
          tipo: {
            id: this.buildElementId("nacionalidade-tipo"),
            label: "Nacionalidade",
            gridExpression: "col s12"
          },
          pais: {
            id: this.buildElementId("nacionalidade-pais"),
            label: "País de origem",
            gridExpression: "col s12 m6"
          },
          dataChegada: {
            id: this.buildElementId("nacionalidade-datachegada"),
            label: "Data de chegada no Brasil",
            gridExpression: "col s12 m6"
          },
          uf: {
            id: this.buildElementId("naturalidade-uf"),
            label: "UF",
            gridExpression: "col s12 m2"
          },
          municipio: {
            id: this.buildElementId("naturalidade-municipio"),
            label: "Município",
            gridExpression: "col s12 m10"
          }
        }
      }
    };
  },
  computed: {
    format() {
      return this.$utils.DateTime.format;
    },
    toBrazilianDate() {
      return this.$utils.DateTime.toBrazilianDate;
    },
    loading() {
      return (
        this.loadingTiposNacionalidade ||
        this.loadingEtnias ||
        this.loadingMunicipio ||
        this.loadingPais
      );
    },
    formattedDataChegada() {
      return this.format(
        this.detalhe.nacionalidade.dataChegada,
        this.toBrazilianDate
      );
    },
    formattedDataNascimento() {
      return this.format(
        this.pessoaFisica.dataNascimento,
        this.toBrazilianDate
      );
    },
    formattedEtnia() {
      const etnia = (this.etnias || []).find(
        item => item.codigo === this.detalhe.etniaCodigo
      );
      return (etnia || {}).nome;
    },
    formattedSexo() {
      return this.pessoaFisica.sexo === "M"
        ? "MASCULINO"
        : this.pessoaFisica.sexo === "F"
        ? "FEMININO"
        : "";
    },
    formattedTipoNacionalidade() {
      const tipoNacionalidade = (this.tiposNacionalidade || []).find(
        item =>
          item.codigo === this.detalhe.nacionalidade.tipoNacionalidadeCodigo
      );
      return (tipoNacionalidade || {}).nome;
    },
    isBrasileiroNato() {
      return this.detalhe.nacionalidade.tipoNacionalidadeCodigo === "1";
    }
  },
  created() {
    this.getTiposNacionalidade();
    this.getEtnias();
    this.getMunicipios();
    this.getPaises();
  },
  methods: {
    buildElementId(name) {
      const id = this.id ? this.id : "dadospessoais";
      return `${id}-${name}`;
    },
    getTiposNacionalidade() {
      this.loadingTiposNacionalidade = true;

      this.tiposNacionalidade = [];

      this.$http
        .get(`${API_URL}/core/tipoNacionalidade`)
        .then(response => (this.tiposNacionalidade = response.data))
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao obter a lista de tipos de nacionalidade: ${error.message}`
          )
        )
        .finally(() => (this.loadingTiposNacionalidade = false));
    },
    getEtnias() {
      this.loadingEtnias = true;

      this.etnias = [];

      this.$http
        .get(`${API_URL}/core/etnia`)
        .then(response => (this.etnias = response.data))
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao obter a lista de etnias: ${error.message}`
          )
        )
        .finally(() => (this.loadingEtnias = false));
    },
    getMunicipios() {
      const { naturalidadeMunicipioId } = this.detalhe;

      this.municipio = { uf: null, nome: null };

      if (naturalidadeMunicipioId) {
        this.loadingMunicipio = true;

        this.$http
          .get(`${API_URL}/core/municipio/${naturalidadeMunicipioId}`)
          .then(response => (this.municipio = response.data))
          .catch(error =>
            this.$notification.pushError(
              `Houve um erro ao obter os dados do município do servidor: ${error.message}`
            )
          )
          .finally(() => (this.loadingMunicipio = false));
      }
    },
    getPaises() {
      const { origemPaisId } = this.detalhe.nacionalidade;

      this.pais = { nome: null };

      if (origemPaisId) {
        this.loadingPais = true;

        this.$http
          .get(`${API_URL}/core/pais/${origemPaisId}`)
          .then(response => (this.pais = response.data))
          .catch(error =>
            this.$notification.pushError(
              `Houve um erro ao obter os dados do país de origem do servidor: ${error.message}`
            )
          )
          .finally(() => (this.loadingPais = false));
      }
    }
  }
};
</script>

<style scoped>
.row {
  margin-bottom: 0;
}

.buttons-row {
  justify-content: right;
}
</style>
